import React from 'react';
import { CheckboxInput } from '../../Form/CheckboxInput';

var Input = function Input(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      errors = _ref.errors,
      handleChange = _ref.handleChange,
      label = _ref.label,
      loading = _ref.loading,
      name = _ref.name,
      topLabel = _ref.topLabel,
      values = _ref.values;
  return /*#__PURE__*/React.createElement(CheckboxInput, {
    checked: values[name],
    className: className,
    disabled: loading || disabled,
    error: errors[name],
    errorText: errors[name] || 'This field is required.',
    id: name,
    label: label,
    name: name,
    onChange: handleChange,
    topLabel: topLabel
  });
};

export { Input };